<template>
        <div class="data-list-container">
              <vs-table :data="histories">

            <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th sort-key="study_year">{{$t('study_year')}}</vs-th>
                <vs-th sort-key="semester">{{$t('semester')}}</vs-th>
                <vs-th sort-key="advisor">{{$t('is_supervisor')}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="tr.uid" v-for="(tr,index) in data">
                    <vs-td :data="tr.uid">
                        {{index+1}}
                    </vs-td>
<!--                    <vs-td>-->
<!--                        <p class="truncate" :data="tr.created">-->
<!--                            {{ getDate(tr.created) }}-->
<!--                        </p>-->
<!--                    </vs-td>-->
                    <vs-td>
                           {{tr.study_year}}
                    </vs-td>
                    <vs-td>
                        {{tr.semester}}
                    </vs-td>
                    <vs-td>
                           {{tr.advisor}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        </div>
</template>


<script>
import axios from '@/configs/Axios'
import userSetting from '@/localNodeModules/setting/user.js'

export default {
    name:'table-store-visor',
    mixins:[userSetting],
    data() {
        return{
            histories: []
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.user.profileId
        },
    },
    mounted() {
        this.getEdvisorHistory();
    },
    methods:{
        getDate(created){
            return this.$moment(created).format('DD.MM.YYYY');
        },
        getOrderStatusColor (status) {
            if (status === 'await')   return 'warning'
            if (status === 'onproccess') return 'info'
            if (status === 'success') return 'success'
            if (status === 'canceled')  return 'danger'
            return 'warning'
        },

        async getEdvisorHistory(){

            await axios.post(`/organizations/story_visor/`,{
                'story_visor': true,
                'student_uid': this.$route.query.uid ? this.$route.query.uid : this.userId
            })
                .then((res)=>{
                    this.histories = res.data
                })
                .catch((err)=>{
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                });
        }

    }

}
</script>
